"use client";

import { motion } from "framer-motion";
import { TypingText } from "../components";

import styles from "../styles";
import { fadeIn, staggerContainer } from "../utils/motion";

const About = () => (
  <section className={`${styles.paddings} relative z-10`}>
    <div className="gradient-02 z-0" />
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <TypingText title="| About DNAU" textStyles="text-center" />

      <motion.p
        variants={fadeIn("up", "tween", 0.2, 1)}
        className="mt-[8px] font-normal sm:text-[32px] text-[20px] text-center text-secondary-white"
      >
        <span className="font-extrabold text-white"> DNA UNIVERSE </span>is a{" "}
        <span className="font-extrabold text-white">
          digital native company
        </span>{" "}
        specializing in creating specialized in creating advanced digital
        experiences, powered by{" "}
        <span className="font-extrabold text-white">
          artificial intelligence.
        </span>{" "}
        We develop intelligent software and innovative solutions in diverse
        areas of work. areas of work. Our multidisciplinary team, with high
        technical technical capabilities, ensures high quality results, offering
        our clients exceptional{" "}
        <span className="font-extrabold text-white">digital experiences.</span>{" "}
        experiences to our clients.
      </motion.p>

      <motion.img
        variants={fadeIn("up", "tween", 0.3, 1)}
        src="/arrow-down.svg"
        alt="arrow down"
        className="w-[18px] h-[28px] object-contain mt-[28px]"
      />
    </motion.div>
  </section>
);

export default About;
